let pathBySlug: { [slug: string]: string } = {};

export const resetSlugUsage = () => {
  pathBySlug = {};
};

export const getSlugForResourcePathName = (pathName: string) => {
  const slug = pathName
    .replace(/\/{.*?}/g, '') // Remove path parameters
    .replace(/^\//, '') // Remove leading slash
    .replace(/\/$/, '') // Remove trailing slash
    .replace(/\//g, '-'); // Replace slashes with dashes

  // This slug is unused, claim it
  if (pathBySlug[slug] === undefined) {
    pathBySlug[slug] = pathName;
    return slug;
  }

  // This slug is already claimed by this resource path
  if (pathBySlug[slug] === pathName) {
    return slug;
  }

  // Some other resource path has this slug, so we need to add a unique identifier
  let i = 1;
  let uniqueSlug = `${slug}-${i}`;
  while (pathBySlug[uniqueSlug] !== undefined && pathBySlug[uniqueSlug] !== pathName) {
    i += 1;
    uniqueSlug = `${slug}-${i}`;
  }

  pathBySlug[uniqueSlug] = pathName;
  return uniqueSlug;
};

export default getSlugForResourcePathName;
